import { styled } from '@uhg-abyss/web/tools/styled';

export const Styles = styled('div', {
  '.tagVariantThreshold.abyss-text-input-left-add-on': {
    padding: 0,
  },
  '.tagVariantThresholdType': {
    '&.abyss-select-input-root': {
      width: '105px',
    },
    border: 'none',
  },
  '#tags': {
    '.abyss-radio-label': {
      fontWeight: 'bold',
    },
    '.abyss-select-input-multi-root': {
      marginTop: 0,
    },
  },
});
